module.exports = __webpack_public_path__ + "static/img/ext3.02599b2d.jpg";